/**
 * Denis Callinan
 * Project Andromeda
 * July 31st, 2020
 * AboutMe.js - 'About' Section
 */

import React from 'react';

// Components
import SectionHeader from '../components/SectionHeader/SectionHeader.js';
import AboutBox from '../components/AboutBox/AboutBox.js';

export default function AboutMe(props) { 
    return(
        <div className = "page" id = "page-A">
            <SectionHeader sectionID = "about-break" title = "ABOUT ME" />
            <AboutBox state = {props.state} />
        </div>
    );
}